import React from 'react';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import { MenuItem } from '../../components/Menu';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import codeIcon from '../../icons/non-prefilled/16x16/code.svg';
import { UIActions } from '../../ui/uiSlice';
import fullOrgUrl from '../../utils/url/fullOrgUrl';
import { postEmbedPath } from '../../utils/url/postPath';
import useShareSecret from '../useShareSecret';

const POST_FRAGMENT = gql(`
  fragment CopyEmbedMenuItem_post on Post {
    ...postEmbedPath_post
  }
`);

interface CopyEmbedMenuItemProps {
  post: DocumentType<typeof POST_FRAGMENT>;
}

const CopyEmbedMenuItem = ({ post }: CopyEmbedMenuItemProps) => {
  const dispatch = useAppDispatch();
  const shareSecret = useShareSecret();
  const embedUrl = fullOrgUrl(postEmbedPath(post, shareSecret));
  const embedHtml = `<iframe src="${embedUrl}" frameborder="0" onmousewheel="" width="100%" height="660" style="background: transparent; border: 1px solid #ccc;"></iframe>`;
  const handleClick = async () => {
    await navigator.clipboard.writeText(embedHtml);
    dispatch(
      UIActions.pushToast({
        level: 'success',
        title: 'Embed code copied',
        message: 'Paste anywhere that supports iframe embeds',
      }),
    );
  };

  return (
    <MenuItem icon={codeIcon} onClick={handleClick}>
      Copy embed
    </MenuItem>
  );
};

export default CopyEmbedMenuItem;
